import Vue from 'vue';
import Vuex from 'vuex';
import mut from '../mutations/settings';


Vue.use(Vuex);

const store = {
    state: {
        locale: JSON.parse(localStorage.getItem('locale')) || 'de-DE',
        localeFallBack: 'de-DE',
        toastTime: 0,
        showFocusWatch: true,
        deviceName: JSON.parse(localStorage.getItem('devName')) || Math.round(Math.random() * 1000).toString(),
    },
    mutations: {
        [mut.SETLANG]: (state, p) => {
            state.locale = p.locale;
            p.t.$i18n.locale = p.locale;
            localStorage.setItem('locale', JSON.stringify(p.locale));
        },
        [mut.SETTOASTTIME]: (state, t) => {
            state.toastTime = t * 1000;
        },
        [mut.SETFOCUSWATCH]: (state, b) => {
            state.showFocusWatch = b;
        },
        [mut.SETDEVICENAME]: (state, n) => {
            state.deviceName = n;
            localStorage.setItem('devName', JSON.stringify(n));
        },
    },
    getters: {
        Locale: state => state.locale,
        LocaleFallBack: state => state.localeFallBack,
        ToastTime: state => state.toastTime,
        ShowFocusWatch: state => state.showFocusWatch,
        DeviceName: state => state.deviceName,
    }

};

export default store;